import CrisisMonitoring from "./crisis-monitoring";

export default CrisisMonitoring;